<template>
<div v-bind:class="{ 'd-none': rutaDelDocumento != null ? false : true }" >
<div class="modal fade bd-example-modal-lg fondo-modal" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
   <!-- <div class="contenedor-opciones">
     <button class="btn btn-light" @click="DescargarArchivo(rutaDelDocumento)">
        <span class="fas fa-file-download fa-2x" >&nbsp;&nbsp;<font style="font-family:Myriad">Descargar</font></span></button>
          <button class="btn btn-light" @click="ImprimirArchivo()">
        <span class="fas fa-print fa-2x" >&nbsp;&nbsp;<font style="font-family:Myriad">Imprimir</font></span></button>
   </div> -->
  <div class="modal-dialog modal-lg">
    <div class="modal-content">  
   <PDFV2 ref="pdf" v-if="rutaDelDocumento != null" :url="rutaDelDocumento" :porPaginas="false" :conDescarga="true" :conImprimir="true" :key="rutaDelDocumento"></PDFV2> 
  <button class="btn btn-danger cerrarElVisor"   @click="CierraElVisor()"><i class="fas fa-times" ></i>&nbsp;&nbsp;&nbsp;&nbsp;Cerrar el documento</button>
    </div>
  </div>
</div>
</div>
    
<!-- <div v-bind:class="{ 'd-none': rutaDelDocumento != null ? false : true }"  > -->
<!-- <button type="button" class="btn btn-primary" data-toggle="modal" data-target=".bd-example-modal-lg">
  Large modal</button> 
{{rutaDelDocumento}} -->
<!-- <div  class="modal fade bd-example-modal-lg con-100" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">

  <div class="modal-dialog modal-lg ">
    <div class="modal-content ">
      -->
      <!-- <PDFDocument class="PDFDocument" v-if="rutaDelDocumento != null" :url="rutaDelDocumento"  :key="rutaDelDocumento"></PDFDocument>  -->
       <!-- <PDFV2  v-if="rutaDelDocumento != null" :url="rutaDelDocumento" :key="rutaDelDocumento" ref="pdfv2"></PDFV2>
      -->
    <!-- <button class="btn btn-secondary btn-descarga" @click="DescargarArchivo(url)"><i class="fa-3x fas fa-file-download"></i></button> -->
   <!-- <div class="contenedor position-fixed">
<button class="botonF1 "  @click="DescargarArchivo(rutaDelDocumento)">
  <span></i></span>
</button>
<button class="btn-opciones botonF2">
  <span></span>
</button>
<button class="btn-opciones botonF3">
  <span>+</span>
</button> -->
<!-- <button class="btn-opciones botonF4">
  <span>+</span>
</button>
<button class="btn-opciones botonF5">
  <span>+</span>
</button> -->
 <!-- </div> -->
         <!-- <button id="cerrarElVisor" class="btn btn-danger btn-flotante" data-dismiss="modal"><i class="fas fa-times"></i>&nbsp;&nbsp;&nbsp;&nbsp;Cerrar el documento</button>
  -->
<!-- </div>
</div>
</div> -->

 <!--<div id="visorDeDocumento_div"  v-bind:class="{ 'd-none': rutaDelDocumento != null ? false : true }">
     
    <div id="cargandoVisorDocumento_div" class="d-flex justify-content-center align-items-center">
       <div id="secciongeneral" class="d-flex flex-wrap justify-content-center align-items-center">
        <div class="d-flex flex-wrap align-items-center justify-content-center"> -->
          <!-- <PDFDocument class="PDFDocument" v-if="rutaDelDocumento != null" :url="rutaDelDocumento" :height="'100%'" :key="rutaDelDocumento"></PDFDocument> -->
     <!--    <PDFV2 v-if="rutaDelDocumento != null" :url="rutaDelDocumento"></PDFV2>
       </div>
        <button id="cerrarElVisor" v-on:click="CierraElVisor()" class="btn btn-danger overwrapDeBotones"><i class="fas fa-times"></i>&nbsp;&nbsp;&nbsp;&nbsp;Cerrar el documento</button>
       </div>   
    </div>
  </div> -->
  
</template>

<script>
import PDFDocument from '@/components/Comunes/PDFDocument.vue';
import PDFV2 from '@/components/Comunes/VisorPDFV2.vue';

import comun from '@/../static/js/comun'
import api from '@/../static/js/api'
import axios from 'axios'

export default {
  components: {
    PDFDocument,
    PDFV2
  }, 
  computed: {
    rutaDelDocumento() {
       $('.bd-example-modal-lg').modal('show')
      return this.$store.getters.Get_PaginaOficial_RutaParaElVisor;
    }
  }, 
  methods: {
    
    ImprimirArchivo(){
    this.$refs.pdf.imprimir();
    },
        DescargarArchivo: function(rutaArchivo) {
          let target =false;
          let href = false;
          var a = document.createElement("a");
            document.body.appendChild(a);
            a.target = (target) ? "_blank" : '';
            a.href = (href) ? rutaArchivo : `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${rutaArchivo}`
            a.click();
  
 },
  
  
    CierraElVisor: function() {
      $('.bd-example-modal-lg').modal('hide')
      this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', null);
    }
  }
}
</script>


<style scoped>
.contenedor-opciones{
  background-color: rgb(209, 208, 208);
  bottom: 0;
    position: sticky !important;
     position: -webkit-sticky !important;
    align-items: center;
    top: 0px;
    width: 100%;
    height: 4em;
    z-index: 1;
    margin-left: 10px;
    text-align: center;
}
header{
  height:170px;
  color:#FFF;
  font-size:20px;
  font-family:Sans-serif;
  background:#009688;
  padding-top:30px;
  padding-left:50px;
}
.contenedor{
  width:90px;
  height:240px;
  position:absolute;
  right:10%;
  z-index: 1;
  top:3%;
}
.botonF1{
  width:60px;
  height:60px;
  border-radius:100%;
  background:#F44336;
  right:0;
  bottom:0;
  position:absolute;
  margin-right:16px;
  margin-bottom:16px;
  border:none;
  outline:none;
  color:#FFF;
  font-size:36px;
  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
  transition:.3s;  
}
span{
  transition:.5s;  
}
.botonF1:hover span{
  transform:rotate(360deg);
}
.botonF1:active{
  transform:scale(1.1);
}
.btn-opciones{
  width:50px;
  height:50px;
  border-radius:100%;
  border:none;
  color:#FFF;
  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
  font-size:28px;
  outline:none;
  position:absolute;
  right:0;
  bottom:0;
  margin-right:26px;
  transform:scale(0);
}
.botonF2{
  background:#2196F3;
  margin-bottom:85px;
  transition:0.5s;
 
}
.botonF3{
  background:#673AB7;
  margin-bottom:140px;
  transition:0.7s;
}
.botonF4{
  background:#009688;
  margin-bottom:175px;
  transition:0.9s;
}
.botonF5{
  background:#FF5722;
  margin-bottom:220px;
  transition:0.99s;
}
.animacionVer{
  transform:scale(1);
}

.cmn-divfloat {
    position: absolute !important;
    bottom: 45px;
    background-color: fuchsia;
    
    display: block;
    float: left;
}
.cmn-btncircle {
    width: 40px !important;
    height: 40px !important;
    padding: 6px 0px;
    border-radius: 15px;
    font-size: 18px;
    text-align: center;
    
}
.contenedor-descarga{
  background-color: forestgreen;

}

.btn-flotante {
position: relative;
height: 4em !important;
}
.fondo-modal{
  width: "100%" !important;
  background-color:  dimgrey;
}
.caja-pdf{
 width:100% !important;
 position: relative;
 background-color: firebrick;
}
  #visorDeDocumento_div {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      z-index: 100 !important;
  }

  #cargandoVisorDocumento_div {
    background: rgba(34,34,34,.5);
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 100 !important
  }

    #cargandoVisorDocumento_div > #secciongeneral > div {
      width: 100vw;
      height: 100vh;
      align-content: center;
    }

    #cargandoVisorDocumento_div > #secciongeneral {
      position: absolute;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(0,0,0,.5);
    }

  .cerrarElVisor {
    bottom: 0;
    position: sticky;
    font-size:2.5vh;
    width: 100%;
    height: 2.5em;
  }

  h3 {
    color: #FFFFFF;
    text-align: center;
    margin-top: 3vh;
  }

  h4 {
    color: #FFFFFF;
    text-align: center;
    margin-bottom: 2vh;
  }

  i {
    color: #FFFFFF;
    position: absolute;
    top: 10px;
    left: 10px;
  }

  .PDFDocument {
    width: 100vw;
    height: 100vh;
  }

@media screen and (min-width: 992px){
.modal-lg {
    max-width: 1200px;
}
}

@media screen and (min-width: 576px){
.modal-dialog {
    max-width: 1300px;
    margin: 1.75rem auto;
}
}
</style>



// WEBPACK FOOTER //
// src/components/SICPO/Comun/VisorDeArchivos.vue